import { render, staticRenderFns } from "./Step2Informative.vue?vue&type=template&id=22d3e419&scoped=true"
import script from "./Step2Informative.vue?vue&type=script&lang=js"
export * from "./Step2Informative.vue?vue&type=script&lang=js"
import style0 from "./Step2Informative.vue?vue&type=style&index=0&id=22d3e419&prod&scoped=true&lang=css"
import style1 from "./Step2Informative.vue?vue&type=style&index=1&id=22d3e419&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d3e419",
  null
  
)

export default component.exports